import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbNavContent } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { RequirementService } from 'src/app/services/requirement.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SendingIdService } from 'src/app/services/sending-id.service';
import { Note } from '../../model/note.model';
import { SendingUseridService } from 'src/app/services/sending-userid.service';
import { NotesValidator } from './validation/notes.validator';
import { UsersService } from '@services/users.service';
import { User } from '@app/docuvision/models/user.model';
import Quill from 'quill';
import { CollaboratorService } from '@services/collaborator.service';
// Importar quill-mention con autoregister - esto registra automáticamente tanto el blot como el módulo
import 'quill-mention/autoregister';


@Component({
    selector: 'app-create-note',
    templateUrl: './create-note.component.html',
    styleUrls: ['./create-note.component.scss'],
    standalone: false
})
export class CreateNoteComponent implements OnInit {
	@Output() insertNote = new EventEmitter<boolean>();
	@Input() requirementId: number;
	newNote: Note = new Note();
	subjectsAlerts: Array<string>;
	collaboratorAssociates: Array<any>;
	newColbAssoc: Array<any>;
	isCheckbox: boolean = true;
	documentId = null;
	editorContent: string = ''; // Inicializa el contenido del editor
	usersSubscribers: Array<any>;
	idReq: number;
	masterSelected1: boolean;
	checkedList1: any;
	listEmailsColab = [];
	emailsColab: string;
	searchText: string = '';
	// var for messages
	errorMessage: string = '';
	successMessage: string = '';
	private _success = new Subject<string>();
	private _error = new Subject<string>();
	showTableAlert: boolean = false;
	loading: boolean = false;
	sentData: boolean = false;
	sentUserId: number;
	// New Form
	notesForm: FormGroup;
	submitted: boolean = false;
	@Input() notes: Note = new Note();
	@Input() idnote: number;
	@Input() edicion: boolean;
	@Input() titelModal: string;
	@Input() path: string;
	@Input() getPath: string;
	@Input() typeId: string; //Contract or Provider
	@Input() requirementtypeid: number;
	@Input() companyId: number;
	@Input() restrictMentionsToCompany = false;
	notes_validation_messages = NotesValidator.NOTES_VALIDATION_MESSAGES;
	users: User[] = [];
	quillConfig: any;
	mappedUsers: any[] = [];
	isServiceContext: boolean = false;



	constructor(
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
		private formBuilder: FormBuilder,
		private sendUserIdServ: SendingUseridService,
		public usersService: UsersService,
		public collaboratorService: CollaboratorService,

	) { }






	ngOnInit() {
		const isContractNote = this.typeId === 'contractid';
		this.isServiceContext = this.path && this.path.includes('globalvision') && !isContractNote;

		this.getUsers();

		if (this.idnote != null) {
			this.obtenerNotes();
		}
		this.sendUserIdServ.currentMessage.subscribe(id => this.sentUserId = id);
		this.notesForm = this.formBuilder.group({
			id: [{ value: null, disabled: true }],
			note: [null, [Validators.required, Validators.minLength(5)]],
			userid: [this.sentUserId, [Validators.required]]
		});


		this.messageSubmitForm();



		this.quillConfig = {
			toolbar: {
				container: [
					['bold', 'italic', 'underline', 'strike'],
					[{ 'size': ['small', false, 'large', 'huge'] }],
					[{ 'list': 'ordered' }, { 'list': 'bullet' }]
				]
			},
			mention: {
				allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
				mentionDenotationChars: ["@", "#"],
				source: (searchTerm, renderList, mentionChar) => {
					let values = [];

					if (mentionChar === "@") {
						values = this.mappedUsers || [];
					}

					if (!values || values.length === 0) {
						renderList([], searchTerm);
						return;
					}

					if (searchTerm.length === 0) {
						renderList(values, searchTerm);
					} else {
						const matches = [];
						for (var i = 0; i < values.length; i++) {
							if (values[i] && values[i].value && ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())) {
								matches.push(values[i]);
							}
						}
						renderList(matches, searchTerm);
					}
				},
			},
		}

	}


	async suggestPeople(searchTerm) {
		const allPeople = [
			{
				id: 1,
				value: "Fredrik Sundqvist"
			},
			{
				id: 2,
				value: "Patrik Sjölin"
			}
		];
		return allPeople.filter(person => person.value.includes(searchTerm));
	}




	obtenerNotes() {
		let url = '';
		if (this.getPath.includes('globalvision')) {
			url = `${this.getPath}/${this.idnote}`;
		} else {
			url = `${this.getPath}/${this.idnote}/requirement/${this.requirementId}`
		}
		this._requirements.geNoteById(url).subscribe(
			data => {
				this.obtenerPatchNote(data['result']);
			},
			error => {
				this._error.next('Error al cargar la actividad.');
			}
		);
	}

	closeModal() {
		this.activeModal.close('Modal Closed');
	}
	//Form Alerts
	submitForm(form: NgForm) {
		if (this.newNote.note === undefined || this.newNote.note.trim() === '') {
			this._error.next('Error: Campo Texto es obligatorio!!!');
		} else {
			this.loading = true;
			// this.newNote.collaborators = this.listEmailsColab;
			this.newNote.id = this.requirementId;
			this.newNote.userid = this.sentUserId;
			this._requirements.createNote(this.newNote, this.path).subscribe(resp => {
				if (resp['error']) {
					this.loading = false;
					this._error.next('Error: No se pudo enviar lo solicitado!!!');
				} else {
					this.loading = false;
					this._success.next('Se realizo correctamente lo solicitado!!!');
					this.activeModal.dismiss();
					this.insertNote.emit(true);
				}
			});
			// clear the object
			this.newNote = new Note();
			this.newNote.note = '';
			// this.newNote.collaborators = [];
			// this is after request
			this.sentData = true;
		}
	}
	retrieveCollab(event) {
		this.listEmailsColab = event;
	}

	// messages for error or success
	messageSubmitForm() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe(
			debounceTime(2000)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe(
			debounceTime(2000)
		).subscribe(() => this.errorMessage = '');
	}
	// DONE

	get f() { return this.notesForm.controls; }
	add() {
		this.loading = true;
		if (this.notesForm.invalid) {
			return;
		}
		this.submitted = true;
		this.notes = this.notesForm.value;
		this.notes.id = this.idnote;

		if (this.edicion) {
			this.edit();
		} else if (this.idnote === null) {
			this.create();
		}

	}

	create() {
		let notesTem: any;
		if (this.path.includes('globalvision')) {
			notesTem = { note: this.notes.note, [this.typeId]: this.requirementId };
		} else {
			notesTem = this.changeObject(this.notes);
		}
		this._requirements.createNote(notesTem, this.path).subscribe(
			data => {
				this._success.next('Se registró una nota correctamente.');
				setTimeout(() => this.activeModal.dismiss(), 2000);
				setTimeout(() => this.insertNote.emit(true), 2000);
				this.reiniciarFormulario();
			},
			error => {
				this._error.next('Error al crear la nota.');
			});
	}

	edit() {
		let notesTem: any;
		if (this.path.includes('globalvision')) {
			notesTem = { id: this.notes.id, note: this.notes.note, [this.typeId]: this.requirementId };
		} else {
			notesTem = this.changeObject(this.notes);
		}

		this._requirements.editNote(notesTem, this.path).subscribe(
			data => {
				this._success.next('Se actualizó la nota correctamente.');
				this.submitted = false;
				setTimeout(() => this.activeModal.dismiss(), 2000);
				setTimeout(() => this.insertNote.emit(true), 2000);
			},
			error => {
				this._error.next('Error al actualizar la nota.');
			});
	}

	reiniciarFormulario() {
		this.notes = new Note();
		this.notesForm.reset();
		this.submitted = false;
	}
	obtenerPatchNote(data) {
		this.notes = this.changeObject(data);
		this.notesForm.patchValue({
			id: this.notes.id,
			note: this.notes.note,
			userid: this.notes.userid,
			idReq: this.notes.idReq
		});
	}

	changeObject(notes: Note) {
		let notesTem: Note = new Note();
		notesTem.id = notes.id;
		notesTem.note = notes.note;
		notesTem.userid = this.sentUserId;
		notesTem.idReq = this.requirementId;

		return notesTem;
	}

	onSelectionChanged($event) {

	}

	/**
	 * Obtiene listado de usuarios (Todos los usuarios activos o Solo los colaboradores candidatos por tipo de requerimiento)
	 */
	getUsers(){
		if (this.typeId === 'contractid') {
			const load = (response) => {
				this.mappedUsers = (response['result'] || []).map(x => ({
					id: x.id,
					value: x.name
				}));
			};
			const onError = () => { this.mappedUsers = []; };
			if (this.restrictMentionsToCompany) {
				if (!this.companyId) {
					this.mappedUsers = [];
					return;
				}
				this.usersService.getUsersByCompany(this.companyId).subscribe(load, onError);
				return;
			}
			this.usersService.getUsers().subscribe(load, onError);
			return;
		}

		if(this.typeId && !this.requirementId){
			this.usersService.getUsers().subscribe(response => {
				this.mappedUsers = (response['result'] || []).map(x => {
					return {
					  id: x.id,
					  value: x.name
					};
				  });
			  }, error => {
				console.error('Error al cargar usuarios:', error);
				this.mappedUsers = [];
			  });

		}else{

			this.collaboratorService.listCollaborators(this.requirementtypeid).subscribe(response => {
				this.mappedUsers = (response['result'] || []).map(x => {
					return {
					  id: x.id,
					  value: x.name
					};
				  });
			  }, error => {
				console.error('Error al cargar colaboradores:', error);
				this.mappedUsers = [];
			  });
		}
	}


}
